import { Component,  Input, OnInit } from '@angular/core';
import { CalendarService } from '@app/services/calendar.service';
import moment from 'moment';
/**
 * Componente que representa un calendario de meses.
 */
@Component({
    selector: 'am-calendar-month',
    templateUrl: './am-calendar-month.component.html',
    styleUrls: ['./am-calendar-month.component.scss'],
    standalone: false
})
export class AmCalendarMonthComponent implements OnInit {
  
 /**
   * Fecha actual que se utiliza como referencia para generar el calendario de meses.
   *
   * @type {any}
   */
 @Input() currentDate: any;

 /**
  * Mes seleccionado que se utiliza para resaltar el mes actual en el calendario.
  *
  * @type {any}
  */
 @Input() monthSelected: any;

 /**
  * Arreglo que almacena la lista de meses generados por el servicio `CalendarService`.
  *
  * @type {any[]}
  */
 monthsArr: any[] = [];

  constructor(
    private _calendarService: CalendarService,
  ) { }

  ngOnInit() {
    const currentDate =  moment();

    this.monthsArr = this._calendarService.createMonthsCalendar(currentDate);
  }
}
